import { brandList } from "./email-templates/brand-data";
import chaseTimeLineData from "./email-templates/chase-timeline-data";
import { EmailDataInterface } from "./email-templates/email-interfaces";

export const BRAND_LIST = brandList.map(({ brandCode, brandName }) => ({ brandCode, brandName }));
export const SEND_WINDOW = "10:00–14:00 UK time";

// ----------------------- MADE-UP SAMPLE DATA ------------------------------------
const PHONE = "03301659367";
const PAYMENT_LINK = "https://inslink.uk/sample";
const SAMPLE = {
  default_date: "14/07/2026",
  vehicle_reg: "AB12 CDE",
  cancellation_date: "05/08/2026",
  next_attempt_date: "20/07/2026",
  outcome_date: "19/07/2026",
  total_due: "57.10",
};

const emailData = (brandCode: string): EmailDataInterface => ({
  ...SAMPLE,
  customername: "Alex Taylor",
  brandCode,
  button1_link: PAYMENT_LINK,
  button2_link: `tel:${PHONE}`,
  button2_num: PHONE,
  monthly_amount: "45.10",
  default_fee: "12.00",
});

// ----------------------- GROUPS AND DAY LABELS ------------------------------------
const GROUPS = [
  {
    key: "arrears",
    title: "Arrears · missed payment",
    blurb: "Sent from the day after a missed Direct Debit until the last chance date. Day 6 sends one of two emails, depending on whether the re-attempt was collected.",
    types: ["arrears", "arrears-approved", "arrears-rejected"],
  },
  {
    key: "addacs",
    title: "Addacs · Direct Debit cancelled",
    blurb: "Sent for 7 days after the customer cancels their Direct Debit, asking them to call and reinstate it.",
    types: ["addacs"],
  },
];

const DAYS = Array.from({ length: 21 }, (_, i) => i + 1);

const badgeFor = (day: number, type: string) => {
  if (day === 21) return "LAST CHANCE DATE";
  if (type === "arrears-approved") return "DAY 6 · COLLECTED";
  if (type === "arrears-rejected") return "DAY 6 · FAILED";
  return `DAY ${day}`;
};

export type Preview = { key: string; badge: string; subject: string; html: string; sms: string | null };

const preview = (brandCode: string, day: number, type: string): Preview | null => {
  const { email, sms } = chaseTimeLineData({ ...SAMPLE, day, type, payment_link: PAYMENT_LINK, phone_number: PHONE });
  if (!email?.template) return null;
  return {
    key: `${type}-${day}`,
    badge: badgeFor(day, type),
    subject: email.subject,
    html: email.template(emailData(brandCode)),
    sms: sms?.message ?? null,
  };
};

export const previewGroups = (brandCode: string) =>
  GROUPS.map((group) => {
    const items = DAYS.flatMap((day) => group.types.map((type) => preview(brandCode, day, type))).filter(Boolean) as Preview[];
    return { ...group, items, meta: `${items.length} emails + SMS · ${SEND_WINDOW}` };
  });
